// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BjZab3lLFBmH1wsn2wLadA\\=\\= {\r\n  background-color: var(--cvna-color-grey-1);\r\n}\r\n", "",{"version":3,"sources":["webpack://src/Account.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;AAC5C","sourcesContent":[".footer {\r\n  background-color: var(--cvna-color-grey-1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": "BjZab3lLFBmH1wsn2wLadA=="
};
export default ___CSS_LOADER_EXPORT___;
